import isEmpty from 'lodash/isEmpty';
import { officeActions } from 'core/Office';
import parseStatus from 'shared/utils/parseStatus';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    ExpandButton,
    PageController
} from 'mol-ui';
import {
    Content,
    EmptyMessage
} from './styled';
import {
    ListingItem,
    ListingLayout
} from 'views/components';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const OfficeListing = () => {

    const dispatch = useDispatch();
    const { push } = useHistory();
    const { listingRoom } = useTheme();
    const { t } = useTranslation();
    const {
        page,
        pageLoading
    } = useSelector('office');
    const commonFilters = {
        limit: 10,
        show_deleted: 1
    };

    useEffect(() => {
        dispatch(officeActions.getOfficePage(commonFilters));
    }, []);

    const handleFilterSearch = ({ search }) => {
        const data = {
            ...commonFilters,
            search
        };
        dispatch(officeActions.getOfficePage(data));
    };

    const handleSelection = (office, mode) => {
        const { id } = office;
        push(`${ t('/consultorios') }/${ mode }/${ id }`);
    };

    const { data: officeList } = page ? page.getData() : { data: [] };
    
    return (
        <ListingLayout
            footer={ isEmpty(officeList) ? undefined : <PageController controller={ page } /> }
            loading={ pageLoading }
            onFilterChange={ handleFilterSearch }
        >
            <Content>
                {
                    officeList && officeList.map(office => {
                        const {
                            address,
                            deleted,
                            doctor = {},
                            house_number,
                            id,
                            name,
                            office_type_id,
                            postal_code,
                            status,
                            virtual
                        } = office;
                        const officeName = `${ name }${ !isEmpty(doctor) ? ` (${ doctor.last_name }, ${ doctor.first_name })` : '' }`;
                        const officeAddress = !virtual ? `${ address ?? '' } ${ house_number ?? '' } ${ postal_code ?? '' }` : t('Sala virtual');
                        return (
                            <ListingItem
                                allowEdit
                                hideAvatar
                                color={ listingRoom }
                                icon={ office_type_id === 1 ? 'domain' : 'phone_iphone' }
                                key={ id }
                                status={ parseStatus(status) }
                                text={ officeAddress }
                                title={ `${ officeName }${ deleted ? ` (${ t('Eliminado') })` : '' }` }
                                onActionClick={ mode => handleSelection(office, mode) }
                            />
                        );
                    })
                }
                {
                    isEmpty(officeList) &&
                    <EmptyMessage>{ t('No hay consultorios') }...</EmptyMessage>
                }
            </Content>
            <ButtonFooter>
                <ExpandButton
                    caption={ t('Nuevo consultorio') }
                    size={ 120 }
                    onClick={ () => push(t('/consultorios/crear')) }
                />
            </ButtonFooter>
        </ListingLayout>
    );

};

OfficeListing.propTypes = {

};

export default OfficeListing;
